import React from 'react';
import { Link } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../lib/ep.js';

const StageManager = function(props) {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const stage_types = [{
		id:1,
		name:i18n("Temporal"),
		description:i18n("Add stages with start and end date. Create weekly or daily stages where your users can participate"),
	}, {
		id:2,
		name:i18n("Sequential"),
		description:i18n("Create a sequence of stages so the users move to the next one only after fullfilling the previous one"),
	}, {
		id:3,
		name:i18n("Paralel Stages"),
		description:i18n("Allow users to participate in one or more of the available stages. Use it to allow users to participate in several categories"),
	}, {
		id:4,
		name:i18n("Advent Calendar"),
		description:i18n("A special temporal group that displays daily stages"),
	}];

	return (
		<div>
			<h2>{i18n("Stage Manager")}</h2>

			<div style={{display:'flex', flexWrap:'wrap'}}>
				{stage_types.map((st) => {
					return (
						<div key={st.id} style={{width:'33%',padding:'10px'}}>
							<Link to={`/stages/manager/${st.id}`}>
								<h3>{st.name}</h3>
							</Link>

							<p>{st.description}</p>
						</div>
					)
				})}
			</div>
		</div>
	);
}

export default injectIntl(StageManager);